import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

const styles = {
  base: {
    height: 100 * 0.65,
  },
  small: {
    height: 50 * 0.65
  },
  extrasmall: {
    height: 15 * 0.65,
  },
}

const OnboardingStepSpacer = ({ classes, small, extrasmall }) => (
  <div
    className={classNames({
      [classes.base]: !small && !extrasmall,
      [classes.small]: small,
      [classes.extrasmall]: extrasmall,
    })}
  />
)

OnboardingStepSpacer.propTypes = {
  classes: PropTypes.object.isRequired,
  small: PropTypes.bool,
  extrasmall: PropTypes.bool,
}

export default withStyles(styles)(OnboardingStepSpacer)
